import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog, Floating } from 'components';
import reported from 'features/views/productionReport';

import Header from './components/Header';
import ReportedDocumentTable from './components/ReportedDocumentTable';

export const ProducedProductionReportModalBody = ({ formData }) => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(reported.actions.reset());
		},
		[dispatch],
	);

	return (
		<Stack spacing={3}>
			<Floating>
				<Dialog mui name={reported.constants.dialogs.documentRecordsLimit}>
					{getLabelMessage('producedProduction:documentRecordsLimit')}
				</Dialog>
			</Floating>
			<Header formData={formData} />
			<ReportedDocumentTable />
		</Stack>
	);
};

ProducedProductionReportModalBody.propTypes = {
	formData: PropTypes.object,
};

export default ProducedProductionReportModalBody;
